import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

export class PaginatorIntlService extends MatPaginatorIntl {
  constructor(private translate: TranslateService) {
    super();
  }

  injectTranslateService() {
    this.translate.onLangChange.subscribe(() => {
      this.translateLabels();
    });

    this.translateLabels();
  }

  translateLabels() {
    this.itemsPerPageLabel = this.translate.instant('PAGINATOR.ITEMS_PER_PAGE');
    this.getRangeLabel = (page, pageSize, length) => {
      let start = ((page * pageSize) + 1);
      let end   = ((page + 1) * pageSize);
      if (length === 0) {
        start = 0;
      }
      if (length <= end) {
        end = length;
      }
      return start + '-' + end + ' ' + this.translate.instant('PAGINATOR.OF') + ' ' + length;
    };
    this.changes.next();
  }

}
